import script from "./ux-itemview.vue?vue&type=script&setup=true&lang=js"
export * from "./ux-itemview.vue?vue&type=script&setup=true&lang=js"

import "./ux-itemview.vue?vue&type=style&index=0&id=9de0c020&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9de0c020"]])

export default __exports__